<template>
  <section class="d-flex flex-column h-full">
    <div class="w-full dk">
      <TopAppBarDrawer
        :isDrawerOpen="isDrawerOpen"
        @closeDrawer="closeDrawer"
      ></TopAppBarDrawer>
      <header
        class="mdc-top-app-bar mdc-top-app-bar--fixed board-header"
        id="app-bar"
        ref="appBar"
        :style="showing"
      >
        <div class="mdc-top-app-bar__row">
          <section
            class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start"
          >
            <div
              class="material-icons mdc-top-app-bar__navigation-icon"
              @click="goToList()"
              @keypress="goToList()"
              tabindex="0"
            >
              arrow_back
            </div>
          </section>

          <section class="mdc-top-app-bar__section title">
            <div class="mdc-top-app-bar__title">{{ $t("3341") }}</div>
          </section>

          <section
            class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end"
          >
            <div
              class="material-icons mdc-top-app-bar__action-item t-color-logoBlue"
              aria-label="search"
              alt="search"
              @click="searchOpen"
              @keypress="searchOpen"
              tabindex="0"
            >
              search
            </div>
          </section>
        </div>
        <!-- <component :is="selectedTabBar"></component> -->
      </header>
      <header class="mdc-top-app-bar" :style="hiding">
        <div class="mdc-top-app-bar__row">
          <section
            class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start"
            @click="searchClose()"
            @keypress="searchClose()"
            tabindex="0"
          >
            <button
              class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button"
              aria-label="Open navigation menu"
            >
              close
            </button>
          </section>
          <section class="mdc-top-app-bar__section title d-flex w-full">
            <div class="mdc-top-app-bar__title pdl-1 font-r w-full pdl-8">
              <input
                type="text"
                :placeholder="$t('3351')"
                class="search_form w-full t-color-tabColor border-none t-subtitle6"
                v-model="contents"
                autofocus
                @keyup="getStoreSerach"
              />
            </div>
          </section>
          <section
            class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end"
            role="toolbar"
            @click="search()"
            @keypress="search()"
            tabindex="0"
          >
            <button
              class="material-icons mdc-top-app-bar__action-item mdc-icon-button"
              aria-label="Search"
            >
              search
            </button>
          </section>
        </div>
      </header>
    </div>
    <main class="mdc-top-app-bar--fixed-adjust">
      <div class="pdb-18 marginB122">
        <div
          class="pdt-12 pdl-12 pdr-12 pdb-4 d-flex"
          v-if="distributionDetail"
        >
          <div
            class="mdc-chip-set mdc-chip-set--choice chip--tag-type p-0 mdc-chip-disabled"
          >
            <div class="demo-chip mdc-chip bg-lecturePurpleBG16" tabindex="0">
              <div class="mdc-chip__ripple"></div>
              <div class="mdc-chip__text t-helper font-r t-color-lecturePurple">
                {{ distributionDetail.checklistPaper.hcategory.text }}
              </div>
            </div>
          </div>
          <div
            class="mdc-chip-set mdc-chip-set--choice chip--tag-type p-0 mdc-chip-disabled"
          >
            <div class="demo-chip mdc-chip bg-lectureYellowBG16" tabindex="0">
              <div class="mdc-chip__ripple"></div>
              <div class="mdc-chip__text t-helper font-r t-color-lectureYellow">
                {{ distributionDetail.checklistPaper.hcategory.child.text }}
              </div>
            </div>
          </div>
        </div>
        <div class="pdl-16 pdr-16">
          <div class="t-subtitle5 t-line-h-26 l-spacing54 font-m">
            {{ distributionDetail ? distributionDetail.name : "" }}
          </div>
          <div
            class="mgt-8 t-body3 t-color-bodyGrayA l-spacing42 t-line-h-20 font-r"
          >
            {{ distributionDetail ? distributionDetail.summary : "" }}
          </div>
          <div class="mgt-12 mgb-16">
            <span class="t-body4 font-r t-color-bodyGrayB">{{
              $t("3342")
            }}</span>
            <span class="t-color-bodyGrayA font-r t-body4 pdl-8"
              >{{
                distributionDetail
                  ? $moment(distributionDetail.periodPolicy.post.start).format(
                      "L"
                    )
                  : ""
              }}
              ~
              {{
                distributionDetail
                  ? $moment(distributionDetail.periodPolicy.post.end).format(
                      "L"
                    )
                  : ""
              }}</span
            >
          </div>
        </div>
        <div class="divider"></div>
        <div
          class="d-flex justify-content-between align-items-center pdt-8 pdb-8 pdl-16 pdr-16 mgb--1"
        >
          <div
            class="t-body3 t-color-bodyGrayA font-r t-line-h-20"
            v-if="totalElements > 0"
          >
            {{ $t("3343", { str: totalElements }) }}
          </div>
          <div class="t-body3 t-color-bodyGrayA font-r t-line-h-20" v-else>
            {{ $t("3343", { str: "0" }) }}
          </div>
          <div class="position-relative p-0">
            <div class="d-flex align-items-center justify-content-end">
              <div
                class="pdl-8 position-relative mdc-menu-anchor menu-container"
              >
                <div
                  class="d-flex t-color-bodyGrayA align-items-center justify-content-end"
                >
                  <div
                    class="t-body3 font-r"
                    @click="toggleMenu"
                    @keypress="toggleMenu"
                    tabindex="0"
                  >
                    {{ menuTypeTitle }}
                  </div>
                  <div
                    class="pdl-16 position-relative mdc-menu-anchor menu-container"
                  >
                    <i
                      class="material-icons js--dropdown-toggle"
                      @click="toggleMenu"
                      @keypress="toggleMenu"
                      >{{ showToggle ? "arrow_drop_up" : "arrow_drop_down" }}</i
                    >
                    <div
                      class="mdc-menu mdc-menu-surface toggle-menu"
                      :class="showToggle ? 'mdc-menu-surface--open' : ''"
                    >
                      <ul
                        class="mdc-list"
                        role="menu"
                        aria-hidden="true"
                        aria-orientation="vertical"
                      >
                        <li
                          class="mdc-list-item min-h-48 d-flex align-items-center"
                          role="menuitem"
                          @click="onSelect('ALL', '3344')"
                          @keypress="onSelect('ALL', '3344')"
                          tabindex="0"
                        >
                          <span class="mdc-list-item__ripple"></span>
                          <span
                            class="mdc-list-item__text t-body6 font-r"
                            :class="
                              menuTypeTitle == 'All'
                                ? 't-color-headlineBlack'
                                : 't-color-bodyGrayA'
                            "
                            >{{ $t("3344") }}</span
                          >
                        </li>
                        <li
                          class="mdc-list-item min-h-48 d-flex align-items-center"
                          role="menuitem"
                          @click="onSelect('SELF', '3350')"
                          @keypress="onSelect('SELF', '3350')"
                          tabindex="0"
                        >
                          <span class="mdc-list-item__ripple"></span>
                          <span
                            class="mdc-list-item__text t-body6 font-r"
                            :class="
                              menuTypeTitle == 'My report'
                                ? 't-color-headlineBlack'
                                : 't-color-bodyGrayA'
                            "
                            >{{ $t("3350") }}</span
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="divider"></div>
        <div
          class="pda-16"
          @click="unsolvedClick"
          @keypress="unsolvedClick"
          v-if="
            exists &&
            exists.activeRespondentPaper &&
            exists.activeRespondentPaper.status === 'SOLVING' &&
            distributionDetail.status.value != 'STOP'
          "
          tabindex="0"
        >
          <div
            class="process-checklist mdc-card b-radius4 pdt-16 pdb-8 pdl-16 pdr-16"
          >
            <div class="t-body1 l-spacing42 t-line-h-24 font-r">
              {{ $t("3347") }}
            </div>
            <div class="mgt-12 mgb-16">
              <span class="t-body4 font-r t-color-bodyGrayB">{{
                $t("3348")
              }}</span>
              <span class="t-color-bodyGrayA font-r t-body4 pdl-8"
                >{{
                  exists && exists.lastSubmitDate
                    ? $moment(exists.lastSubmitDate).format("L")
                    : ""
                }}
                {{
                  exists.lastSubmitDate
                    ? $moment(exists.lastSubmitDate).format("HH:mm")
                    : ""
                }}</span
              >
            </div>
            <div class="t-right">
              <button
                type="button"
                class="mdc-button mgr--8"
                @click.stop="deleteAnswer"
                @keypress.stop="deleteAnswer"
                tabindex="0"
              >
                <div class="mdc-button__ripple"></div>
                <span
                  class="mdc-button__label t-color-secondaryBtnText font-r"
                  >{{ $t("3349") }}</span
                >
              </button>
            </div>
          </div>
        </div>
        <div
          class="d-flex checklist-detail-list pdb-16 pdl-16 pdr-16"
          v-for="(checklist, index2) in detail"
          :key="index2"
          @click="goToCommentSection(checklist)"
          @keypress="goToCommentSection(checklist)"
          tabindex="0"
        >
          <!-- 개별 점수 주석 처리 -->
          <!-- <div class="min-w-90 pdt-16">
            <div class="t-color-contentBlue t-helper t-center font-r">
              Score
            </div>
            <div
              class="t-headline5 t-line-h-22 t-color-contentBlue t-center font-rb t-line-h-34"
            >
              {{
                checklist && checklist.totalScore ? checklist.totalScore : "0"
              }}
            </div>
          </div> -->

          <!-- 체크리스트 이름/직책 휴면, 탈퇴 처리 -->
          <div class="flex-grow-1 mgt-16">
            <div class="t-body3 font-r l-spacing42 t-line-h-20">
              {{ handleUserName(checklist.member) }}
            </div>
            <div class="mgt-1">
              <div v-if="checkDeactivateUser(checklist.member)">
                <span
                  class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA right-divider position-relative"
                >
                  {{
                    checklist && checklist.member.brandName
                      ? checklist.member.brandName
                      : brandName
                  }}
                </span>
              </div>
              <div v-else>
                <span
                  class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA right-divider position-relative"
                  >{{ checklist ? checklist.member.dutyName : "" }}</span
                >
                <span
                  class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA right-divider position-relative"
                  >{{
                    checklist ? checklist.member.responsibilityName : ""
                  }}</span
                >
              </div>
            </div>
            <div
              class="mgt-12 d-flex justify-content-between align-items-baseline flex-grow-1"
            >
              <div class="t-body4 font-rn t-color-bodyGrayA">
                {{
                  checklist && checklist.lastSubmitDate
                    ? $moment(checklist.lastSubmitDate).format("L")
                    : ""
                }}
                {{
                  checklist && checklist.lastSubmitDate
                    ? $moment(checklist.lastSubmitDate).format("HH:mm")
                    : ""
                }}
              </div>
              <div class="t-helper font-r t-color-bodyGrayA">
                {{
                  checklist && checklist.commentCount
                    ? $t("3345", { str: checklist.commentCount })
                    : $t("3345", { str: 0 })
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="pdt-30 t-center" v-if="isNoData">
          <img
            src="/images/board/no-board-data.svg"
            alt=""
            class="w120 mgl-auto mgr-auto"
            v-if="!searchOpenNodata"
          />
          <div
            class="t-center t-subtitle font-m l-spacing48 t-line-h-20"
            v-if="!searchOpenNodata"
          >
            {{ $t("3443") }}
          </div>
          <div
            class="t-center t-subtitle font-m l-spacing48 t-line-h-20"
            v-if="contents && searchOpenNodata"
          >
            {{ $t("3352") }}
          </div>
          <div
            class="t-center t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA mgt-8"
            v-if="contents && searchOpenNodata"
          >
            {{ $t("3353") }}
          </div>
        </div>
      </div>
      <div class="fab-contrainer">
        <button
          class="mdc-fab mdc-fab--extended bg-mainBtn"
          @click="moveToQuestion"
          @keypress="moveToQuestion"
          v-if="distributionDetail.status.value != 'STOP'"
          tabindex="0"
        >
          <div class="mdc-fab__ripple"></div>
          <span class="material-icons mdc-fab__icon t-color-white">edit</span>
          <span class="mdc-fab__label font-r t-body2 t-color-white">{{
            $t("3346")
          }}</span>
        </button>
      </div>
    </main>
    <infinite-loading
      @infinite="fetchData"
      :identifier="infiniteId"
      spinner="spiral"
    >
      <div slot="no-more" class="mgt-16"></div>
      <div slot="no-results" class="mgt-16"></div>
    </infinite-loading>
    <div
      class="mdc-dialog__scrim backlayer"
      :class="showToggle ? 'show' : ''"
      @click="toggleMenu"
    ></div>
    <!-- <div class="backlayer"></div> -->
  </section>
</template>

<script>
import { MDCMenu } from "@material/menu";
import checklistApi from "@/api/checklistApi.js";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import { userMixin } from "../../mixins/user.js";
import InfiniteLoading from "vue-infinite-loading";

export default {
  data() {
    return {
      menuBar: null,
      detail: [],
      distributionDetail: null,
      contents: "",
      isNoData: false,
      isDrawerOpen: false,
      menuTypeTitle: this.$t("3344"),
      slectedMenuType: "ALL",
      distributionId: null,
      storeId: null,
      firstCharOfNames: localStorage.getItem("firstChar"),
      bgColorOfName: localStorage.getItem("bgColors"),
      currentPage: 1,
      totalPages: 1,
      infiniteId: +new Date(),
      showing: { display: "block" },
      hiding: { display: "none" },
      backFixLayer: false,
      unSolvedIndex: null,
      showHide: false,
      exists: [],
      totalElements: 0,
      searchOpenNodata: false,
      showToggle: false,
      brandName: localStorage.getItem("brandName"),
    };
  },

  components: {
    TopAppBarDrawer,
    InfiniteLoading,
  },

  mixins: [topAppBarMixin, userMixin],

  watch: {
    $route(to, from) {
      this.initData();
    },
  },

  mounted() {
    console.log("mounted", this.menuTypeTitle);
    let responseData = null;
    this.distributionId = this.$route.params.postId;

    const menuEls = Array.from(document.querySelectorAll(".mdc-menu"));
    menuEls.forEach((menuEl) => {
      this.menuBar = new MDCMenu(menuEl);
      const dropdownToggle = menuEl.parentElement.querySelector(
        ".js--dropdown-toggle"
      );
      dropdownToggle.addEventListener("click", () => {
        this.menuBar.open = !this.menuBar.open;
      });
    });

    checklistApi
      .fetchMember()
      .then((response) => {
        console.log("response", response);
        responseData = response.data.data;
        this.storeId = responseData.storeId;
        this.exist();
      })
      .catch((err) => {
        console.log(err);
      });
    this.getDetail();
  },

  methods: {
    toggleMenu() {
      this.showToggle = !this.showToggle;
    },
    openDrawer() {
      this.isDrawerOpen = true;
    },
    // Close drawer
    closeDrawer() {
      this.isDrawerOpen = false;
    },

    initData() {
      this.detail = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1;
    },

    //Alert box delete
    deleteAnswer() {
      this.$confirm({
        content: this.$t("3358"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
        accept: this.$t("3360"), // 확인
        cancel: this.$t("3359"), //'TODO-취소'
      })
        .then(() => {
          this.$showLoading();
          checklistApi
            .deleteAnswer(this.exists.id)
            .then((response) => {
              if (response.data.data == true) {
                // this.initData();
                this.exist();
              }
              this.$hideLoading();
            })
            .catch((err) => {
              this.$hideLoading();
              //this.$error({content: err.errMsg}).then(() => {
              // });
            });
        })
        .catch(() => {});
    },

    //Delete post by loggedIn user
    // deletePost() {
    //     this.$showLoading();
    //         boardApi.deletePost(this.$route.params).then((response) => {
    //             this.$hideLoading();
    //             this.goToPrevious()
    //             //this.$router.push('/socialLearning?board='+this.boardId+'&boardName='+encodeURI(this.boardName))
    //         }).catch((err) => {
    //             this.$hideLoading();
    //             this.$error({ content: err.errMsg }).then(() => {});
    //         });
    // },

    getDetail() {
      this.$showLoading();
      checklistApi
        .checkListDistributionDetails(this.$route.params)
        .then((response) => {
          this.distributionDetail = response.data.data;

          this.$hideLoading();
        })
        .catch((err) => {
          this.$hideLoading();
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },

    fetchData($state) {
      let responseData = null;
      let params = this.setParams();

      if (this.totalPages >= this.currentPage) {
        checklistApi
          .checkListDetails(this.distributionId, this.storeId, params)
          .then((response) => {
            console.log("response", response);
            responseData = response.data.data;
            this.totalElements = responseData.totalElements;
            this.detail = this.detail.concat(responseData.content);
            if (responseData.content.length > 0) {
              let getIndex =
                this.detail[0].activeRespondentPaper.groups.forEach(
                  (element, index, array) => {
                    if (element.response == false) {
                      this.unSolvedIndex = index;
                    }
                  }
                );
            }
            // console.log('hhhhh')
            // console.log(responseData.content.length)
            // console.log('unSolvedIndex',this.unSolvedIndex);
            this.currentPage++;
            this.totalPages = responseData.totalPages;

            if (responseData.content.length > 0) {
              $state.loaded();
            } else {
              $state.complete();
            }
            if (this.contents && responseData.content.length > 0) {
              this.searchOpenNodata = false;
            } else if (this.contents && responseData.content.length <= 0) {
              this.searchOpenNodata = true;
            }
            if (responseData.content.length > 0) {
              this.isNoData = false;
            } else {
              this.isNoData = true;
            }
          })
          .catch((err) => {
            $state.error();
          });
      } else {
        $state.complete();
      }
    },

    setParams() {
      const params = {
        memberName: this.contents,
        sortType: this.selectedMenuType,
        page: this.currentPage,
        size: 10,
        sort: "id,desc",
      };
      return params;
    },

    // Filter type(ALL,My Report)
    onSelect(type, lang) {
      this.menuTypeTitle = this.$t(lang);
      this.selectedMenuType = type;
      this.initData();
      this.showToggle = false;
    },

    searchOpen() {
      this.showing = { display: "none" };
      this.hiding = { display: "block" };
    },

    searchClose() {
      this.contents = "";
      this.initData();
      this.$router.go(this.$router.currentRoute);
      this.showing = { display: "block" };
      this.hiding = { display: "none" };
    },

    search() {
      this.initData();
      //this.getStaticData();
      this.showing = { display: "none" };
      this.hiding = { display: "block" };
    },
    // Recent Serach Suggestion
    getStoreSerach() {
      let charSearch = JSON.parse(localStorage.getItem("datas"));
      let searchResult = charSearch.includes(this.contents);
      if (searchResult === true) {
        this.storeSearch = charSearch;
      } else {
        this.storeSearch = "";
      }
    },
    askForModify() {
      this.$router.push({
        name: "BoardModify",
        params: {
          boardId: this.$route.params.boardId,
          postId: this.$route.params.postId,
        },
        query: this.$route.query,
      });
    },
    unsolvedClick() {
      //console.log('parent')
      this.$router.push({
        name: "CheckListQuestionTake",
        params: { postId: this.$route.params.postId },
        query: { groupIndex: this.unSolvedIndex + 1 },
      });
    },
    moveToQuestion() {
      // checklistApi.answeredByUser(this.$route.params.postId).then((response) => {
      //   console.log(response.data.data)
      // debugger;
      if (
        this.exists &&
        this.exists.activeRespondentPaper &&
        this.exists.activeRespondentPaper.status === "SOLVING"
      ) {
        this.$confirm({
          title: this.$t("3354"),
          content: this.$t("3355"),
          accept: this.$t("3357"),
          cancel: this.$t("3356"),
        })
          .then(() => {
            this.$router.push({
              name: "CheckListQuestionTake",
              params: { postId: this.$route.params.postId },
              query: { groupIndex: this.unSolvedIndex + 1 },
            });
          })
          .catch(() => {
            checklistApi
              .resetQuestionAnswered(this.exists.id)
              .then((response) => {
                this.$router.push({
                  name: "CheckListQuestionTake",
                  params: { postId: this.$route.params.postId },
                });
              })
              .catch((err) => {});
          });
      } else {
        this.$router.push({
          name: "CheckListQuestionTake",
          params: { postId: this.$route.params.postId },
        });
      }
      // this.distributionDetail = response.data.data;
      // this.$hideLoading();
      // }).catch((err) => {
      //   this.$hideLoading();
      //   this.$error({content: err.errMsg}).then(() => {
      //   });
      // });

      // this.$alert({
      // 	title: this.$t('3354'),
      // 	content: this.$t("3355"),
      // 	accept: this.$t("3357"),
      // 	cancel: this.$t("3356"),
      // }).then(() => {
      // 	this.$router.push({
      // 		name: 'CheckListQuestionTake',
      // 		params: {postId:this.$route.params.postId}
      // 	})
      // }).catch(() => {
      // 		checklistApi.(this.$route.params).then((response) => {
      // 		this.distributionDetail = response.data.data;
      // 		this.$hideLoading();
      // 	}).catch((err) => {
      // 		this.$hideLoading();
      // 		this.$error({ content: err.errMsg }).then(() => {});
      // 	});
      // 	checklist/respondent/exist
      // });
    },

    goToList() {
      this.$router.push({
        name: "CheckList",
      });
    },
    goToCommentSection(checklist) {
      this.$router.push({
        name: "SubmittedResult",
        params: {
          postId: checklist.id,
        },
      });
    },
    exist() {
      console.log("exist init", this.$route.params.postId, this.storeId);
      checklistApi
        .answeredByUser(this.$route.params.postId, this.storeId)
        .then((response) => {
          //console.log(response.data.data , ' ___')
          this.exists = response.data.data;
          if (response.data.data.activeRespondentPaper.groups) {
            response.data.data.activeRespondentPaper.groups.some(
              (value, index) => {
                this.unSolvedIndex = index;
                return value.response === false;
              }
            );
          }
        })
        .catch((err) => {
          this.$hideLoading();
          // this.$error({content: err.errMsg}).then(() => {
          // });
        });
    },
  },
};
</script>


<style scoped>
.w120 {
  height: 120px;
}

.fab-contrainer {
  position: fixed;
  bottom: 34px;
  width: 100%;
  text-align: center;
}

.toggle-menu {
  top: 32px !important;
  right: 0 !important;
  left: auto !important;
}
.mdc-chip {
  height: 24px;
}

.mdc-menu-background {
  z-index: 1;
}
</style>